import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { shareIcons } from '../../shared/styles/icons';
import { shareLinks } from '../../shared/constants';
import { styles } from '../components/styles/VideoModalShareStyles';
import Viewports from '../../../assets/components/fsUtils/Viewports';

class VideoModalShare extends React.Component {
	constructor(props){
        super(props);

        this.state = {
            url: this.props.videoUrl,
            videoUrl: encodeURIComponent(this.props.videoUrl), 
            title: this.props.title
        }

        this.viewport = new Viewports();
        
        this.handleCopyToClipboard = (e) => {
            let message = 'Link copied to clipboard ';
            let textArea = document.getElementById('cpyLink');
            textArea.select();
            try {
                document.execCommand('copy');
            } catch(e) {
                console.log('Oops, unable to copy', e.message);
            }
        }
        
    }

    componentDidMount() {
    }

    componentDidUpdate(){

    }
    

	render() {        
        let url = this.props.videoUrl;
        let videoUrl = encodeURIComponent(this.props.videoUrl);
        let title =  this.props.title;

        this.shareLinks = {
            fb: shareLinks.FB_SHARE +  videoUrl + '&utm_source=share_fb',
            tw: shareLinks.TWITTER_SHARE +  videoUrl + '&utm_source=share_tw&&via=FoxSports&text=' + title,
            em: shareLinks.MAIL + encodeURIComponent('Read more @FOXSports - ' + title) + '&body=Read more @FOXSports - ' + title + ' - ' +  videoUrl + '&utm_source=share_em'
        }
		return (
            <div className={css(shareIcons.inlineContainer)}>
                <input id="cpyLink" value={url} className={css(styles.hidden)}/>
                <a href={this.shareLinks.fb} 
                    target="_blank"> <span className={css([shareIcons.icFBShare, shareIcons.icShare])}></span> </a>
                <a href={this.shareLinks.tw} target="_blank">
                     <span className={css([shareIcons.icTwitterShare, shareIcons.icShare ])}></span> </a>
                 { !this.viewport.isTouch && <button className={css([shareIcons.icLinkShare, shareIcons.icShare])} onClick={this.handleCopyToClipboard}> </button> }
                <a href={this.shareLinks.em}> <span className={css([shareIcons.icEmailShare, shareIcons.icShare])} target="_blank"></span> </a>
                
            </div>
		);
	}

}

export default VideoModalShare;



// WEBPACK FOOTER //
// ./react-app-src/videoModal/components/VideoModalShare.js